export default __webpack_public_path__ + "37cb8076b447b46fdb3943ea53b9ff49.png";